export default __webpack_public_path__ + "static/media/Party-Room.d38b7b7d.webp";